<div class="contact">
	<ng-content select="header" />
</div>
<div class="main">
	<div class="sidenav" [class.no-menu]="!menuItems()?.length">
		<ic-sidebar [items]="menuItems()" />
	</div>
	<div class="size-full grid grid-rows-[auto_1fr]">
		<div class="filters">
			<ng-content select="ic-page-filter" />
		</div>
		<div class="contents-body" data-test="page-contents">
			<ng-content select="[contents]" />
		</div>
	</div>
</div>
